export const RESOLVER_URL = 'https://experiences.resolver.algolia.com';
